//   Generated by Paratype Generator

import { Injectable } from '@angular/core';
import { BaseServiceV2 } from '@common/service/base.service-v2';
import { FacturaDTO } from '@gen/factura/factura.dto';

@Injectable({
  providedIn: 'root'
})
export class FacturaService extends BaseServiceV2<FacturaDTO> {
  override entityUrl = 'factura';
  override entityName = 'Factura';
}
